module.exports = (__webpack_require__(0))(27);


//////////////////
// WEBPACK FOOTER
// delegated ./src/constants.js from dll-reference girder_plugin_jobs
// module id = 21
// module chunks = 0